import React, { useState, useEffect } from 'react';
import { Cloud, Sun, CloudRain, MapPin, Clock } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { motion } from 'framer-motion';

const WeatherClock = () => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [weather] = useState({
    temp: 72,
    condition: 'Sunny',
    location: 'Hollywood, CA'
  });

  const worldClocks = [
    { city: 'Los Angeles', offset: -8, flag: '🇺🇸' },
    { city: 'New York', offset: -5, flag: '🇺🇸' },
    { city: 'London', offset: 0, flag: '🇬🇧' },
    { city: 'Tokyo', offset: 9, flag: '🇯🇵' },
    { city: 'Sydney', offset: 11, flag: '🇦🇺' }
  ];

  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const getTimeForOffset = (offset) => {
    const utc = currentTime.getTime() + (currentTime.getTimezoneOffset() * 60000);
    const cityTime = new Date(utc + (3600000 * offset));
    return cityTime.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
  };

  return (
    <motion.div 
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="fixed top-20 right-4 z-40 hidden lg:block"
    >
      <Card className="bg-white/95 backdrop-blur-xl shadow-2xl border border-yellow-500/20">
        <CardContent className="p-4 space-y-4">
          {/* Weather */}
          <div className="flex items-center gap-3 pb-3 border-b border-gray-200">
            <div className="bg-gradient-to-br from-yellow-400 to-orange-500 p-3 rounded-full">
              <Sun className="h-6 w-6 text-white" />
            </div>
            <div>
              <p className="text-2xl font-black text-gray-900">{weather.temp}°F</p>
              <p className="text-xs text-gray-600 flex items-center gap-1">
                <MapPin className="h-3 w-3" />
                {weather.location}
              </p>
            </div>
          </div>

          {/* World Clocks */}
          <div className="space-y-2">
            <p className="text-xs font-bold text-gray-500 uppercase tracking-wider flex items-center gap-1">
              <Clock className="h-3 w-3" />
              World Times
            </p>
            {worldClocks.map((clock, idx) => (
              <motion.div
                key={clock.city}
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: idx * 0.1 }}
                className="flex items-center justify-between text-sm"
              >
                <span className="flex items-center gap-2">
                  <span className="text-lg">{clock.flag}</span>
                  <span className="font-medium text-gray-700">{clock.city}</span>
                </span>
                <span className="font-bold text-yellow-600">{getTimeForOffset(clock.offset)}</span>
              </motion.div>
            ))}
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default WeatherClock;
